<template><a :href="framework_path" class="k-fwcc-doc-link" :aria-label="framework_link_label" @click.prevent.stop="view_framework">
	<div class="k-fwcc-doc-item" :class="document_class" :style="tile_color_style">
		<div class="k-fwcc-doc-title" :style="{color: tile_text_color} ">
			<!-- <div><k-icon small class="mr-2" color="#fff">fas fa-map</k-icon></div> -->
			<span>
				<k-tooltip top><template v-slot:activator="{on}">
					<k-icon v-on="on" v-if="is_sandbox" small class="mr-1" style="margin-top:-6px" :color="tile_text_color">fas fa-umbrella-beach</k-icon>
				</template><div class="text-center">This is a “sandbox” copy of the original framework.</div></k-tooltip>

				<k-tooltip top><template v-slot:activator="{on}">
					<k-icon v-on="on" v-if="is_private" small class="mr-1" style="margin-top:-6px" :color="tile_text_color">fas fa-user-secret</k-icon>
				</template><div class="text-center">This framework is PRIVATE:<br>it will only be visible to explicitly-authorized users.</div></k-tooltip>

				<span class="k-fwcc-doc-title-text" v-html="doc.title"></span>
			</span>
			<k-spacer />
			<div v-if="image_src" class="k-fwcc-framework-image-wrapper">
				<!-- The title already names the framework, so this thumbnail is decorative and should not be announced twice. -->
				<k-img
					:src="image_src"
					decorative
					contain
					class="k-fwcc-framework-image"
				/>
			</div>
		</div>
	</div>
</a></template>

<script>
import { mapState, mapGetters } from 'vuex'
import goTo from 'vuetify/lib/services/goto'

export default {
	components: { },
	props: {
		framework_record: { type: Object, required: true },
		case_tree_lsdoc_identifier: { type: String, required: false, default() { return '' }},
	},
	data() { return {
	}},
	computed: {
		...mapState(['user_info']),
		doc() { return this.framework_record.json.CFDocument },
		is_sandbox() { return !empty(this.framework_record.ss_framework_data.sandboxOfIdentifier) },
		is_private() { return U.framework_is_private(this.framework_record) },
		case_tree_lsdoc_identifier_is_shortcut() { return vapp.framework_list_component.case_tree_lsdoc_identifier_is_shortcut },
		color_class() {
			const framework_color = U.framework_color(this.doc.identifier)
			if (!isNaN(framework_color)) return 'k-framework-color-' + framework_color
			return ''
			// e.g. 'k-framework-color-0', which sets background-color to a light version; add -med, -dark, -border, or -text if necessary
		},

		document_class() {
			let s = 'k-fw-document-card-' + this.doc.identifier

			// add class if this framework's tree is currently showing, or if another framework's tree is showing
			if (this.doc.identifier == this.case_tree_lsdoc_identifier) {
				s += ' k-fwcc-doc-item-showing'	//  elevation-2'
			} else if (this.case_tree_lsdoc_identifier && !this.case_tree_lsdoc_identifier_is_shortcut) {
				s += ' k-fwcc-doc-item-other-item-showing'
			}

			// add class for sandboxes
			if (this.is_sandbox) s += ' k-fwcc-doc-item-sandbox'

			if (this.color_class) {
				s += ' ' + this.color_class + '-dark'
			}

			return s
		},
		framework_path() {
			return `/${this.doc.identifier}`
		},
		tile_background_color() {
			return U.resolve_framework_color_value(this.framework_record, U.is_custom_color(this.framework_record) ? '' : 'dark')
		},
		tile_color_style() {
			return U.framework_color_object(this.framework_record)
		},
		tile_text_color() {
			return U.get_accessible_text_color(this.tile_background_color, '#FFFFFF')
		},
		image_src() {
			return U.framework_image_src(this.framework_record)
		},
		framework_link_label() {
			const parts = [this.doc.title]
			if (this.is_sandbox) parts.push('Sandbox framework')
			if (this.is_private) parts.push('Private framework')
			return parts.join('. ')
		},
	},
	watch: {
	},
	created() {
	},
	mounted() {
	},
	methods: {
		view_framework($event) {
			this.$emit('view_framework', [this.doc.identifier, null, $event])
		},
	}
}
</script>

<style lang="scss">
.k-fwcc-doc-link {
	display:block;
	text-decoration:none;
	border-radius:8px;
}

.k-fwcc-doc-item {
	border:4px solid transparent;
	padding:8px;
	margin:8px;
	border-radius:8px;
	width:300px;
	min-height:72px;
	cursor:pointer;
}

.k-fwcc-doc-title {
	font-size:16px;
	display:flex;
	align-items: top;
	line-height:18px;
}

.k-fwcc-doc-item:hover {
	.k-fwcc-doc-title-text {
		text-decoration:underline;
	}
}

.k-fwcc-doc-link:focus-visible {
	outline:none;
	.k-fwcc-doc-item {
		box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.3);
	}
	.k-fwcc-doc-title-text {
		text-decoration:underline;
	}
}

.k-fwcc-doc-item-showing {
	.k-fwcc-doc-title-text {
		font-weight:bold;
	}
}

.k-fwcc-doc-item-other-item-showing {
	opacity:0.5;
}

.k-fwcc-doc-item-sandbox {
	border: 4px dashed #aaa!important;
}

.k-fwcc-framework-image-wrapper {
	flex: 0 0 83px;
	width: 83px;
    height: 83px;
    border-radius: 6px;
    background-color: #fff;
	// background-color:rgba(255,255,255,0.9);
    padding: 3px;
	margin-left:8px;
	display: flex;
	align-items: center;
	justify-content: center;
    // margin: 4px 8px 0 8px;
	img {
		max-width: 77px;
		max-height:77px;
		border-radius:5px;
		opacity:0.8;
	}
}

.k-fwcc-framework-image {
	width: 77px;
	height: 77px;
	border-radius: 5px;
	opacity: 0.8;
}
</style>
